<body>
    <div id="top-border">
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-4" style="margin-top: 30px;">
                <a class="footer-links" routerLink="/plant-place-store" routerLinkActive="active">Plant Place Store</a>
                <a class="footer-links" routerLink="/plants-gallery" routerLinkActive="active">Plants Gallery</a>
                <a class="footer-links" routerLink="/home-gardening" routerLinkActive="active">Home Gardening</a>
                <a class="footer-links" routerLink="/stay-connected" routerLinkActive="active">Stay Connected</a>
            </div>
            <div class="col-sm-4">
                
            </div>
            <div class="col-sm-4" style="margin-top: 30px;">
                <div class="box-shadow" style="background-color:white;border-radius:15px;padding:25px;">
                    <h4 style="text-emphasis: 30px;"><strong>Stay Connected</strong></h4>
                    <table>
                        <tr style="padding:15px;">
                            <td><img src="assets/social/fb.png" style="width:36px;height:36px;border-radius:100%;"></td>
                            <td><a class="social-links" href="https://www.facebook.com/plantplaceph" style="color:black;font-size:18px;font-weight:lighter;margin-left:5px;text-decoration: none;">plantplaceph</a></td>
                        </tr>
                        <tr style="padding:15px;">
                            <td><img src="assets/social/ig.png" style="width:36px;height:36px;border-radius:100%;"></td>
                            <td><a class="social-links" href="https://www.instagram.com/leebertc45tr0/" style="color:black;font-size:18px;font-weight:lighter;margin-left:5px;text-decoration: none;">leebertc45tr0</a></td>
                        </tr>
                        <tr style="padding:15px;">
                            <td><img src="assets/social/yt.png" style="width:36px;height:36px;border-radius:100%;"></td>
                            <td><a class="social-links" href="https://www.youtube.com/channel/UCWqFH0X3W2MtbovVxTJdDtg" style="color:black;font-size:18px;font-weight:lighter;margin-left:5px;text-decoration: none;">Leebert Castro</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row footer">
            <div class="col-sm-4">

            </div>
            <div class="col-sm-4">
                <p class="text-center">Plant Place Ph</p>
                <p class="text-center">Copyright &#169;2020 All Rights Reserved</p>
            </div>
            <div class="col-sm-4">

            </div>
        </div>
    </div>
</body>
